import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { slugify } from '../../../utils/slugify';
import { supabase } from '../../../utils/supabase';

function GolfCourseRank({ course }) {
  const [countryCourseCount, setCountryCourseCount] = useState(0);
  const [countyFlagURL, setCountyFlagURL] = useState(''); // State for flag URL
  const [countryFlagURL, setCountryFlagURL] = useState(''); // State for flag URL

  const rankMapping = {
    England: 'england_rank_gl',
    'Northern Ireland': 'ni_rank_gl',
    USA: 'usa_rank_gl',
    Scotland: 'scotland_rank_gl',
    Ireland: 'ireland_rank_gl',
    Wales: 'wales_rank_gl',
  };

  const countryRankField = rankMapping[course.course_country];
  const countryRank = course[countryRankField];

  useEffect(() => {
    // Function to set the flag URL
    const updateCountryFlagURL = () => {
      const slugCountry = slugify(course.course_country); // Convert Country name to slug
      const url = `https://api.golflists.com/storage/v1/object/public/country-flags/${slugCountry}.webp`;
      setCountryFlagURL(url);
    };

    // Update flag URL if course_county is available
    if (course.course_country) {
      updateCountryFlagURL();
    }

    const updateCountyFlagURL = () => {
      const slugCounty = slugify(course.course_county); // Convert county name to slug
      const url = `https://api.golflists.com/storage/v1/object/public/county-flags/${slugCounty}.webp`;
      setCountyFlagURL(url);
    };

    // Update flag URL if course_county is available
    if (course.course_county) {
      updateCountyFlagURL();
    }

    // Function to fetch country course count
    const fetchCountryCourseCount = async () => {
      // head: true — count only, no row payload (faster than select + count on large tables)
      const { count } = await supabase
        .from('golf_courses')
        .select('*', { count: 'exact', head: true })
        .eq('course_country', course.course_country);
      setCountryCourseCount(count ?? 0);
    };

    // Fetch country course count if course is available
    if (course) {
      fetchCountryCourseCount();
    }
  }, [course]); // Dependency array includes course to re-run useEffect when course changes

  // Calculate the top percentage (assuming `countyCourseCount` is not zero)
  const countryPercentage =
    countryCourseCount !== 0 ? (countryRank / countryCourseCount) * 100 : 0;

  const roundedPercentage =
    countryPercentage > 0 ? Math.ceil(countryPercentage) : 0;

  return (
    <article
      id="golfCourseRank"
      className="h-fit lg:h-[185px] py-4 grid grid-cols-3 mt-1 w-full text-left rounded-xl bg-white shadow-lg"
    >
      <Link
        to={`/lists/golf-courses/rankings?country=${encodeURIComponent(course.course_country)}`}
        className="flex flex-col gap-y-2 justify-center items-center cursor-pointer hover:border hover:border-gray-300 hover:rounded-xl"
      >
        {countryFlagURL && (
          <img
            src={countryFlagURL}
            alt={`${course.course_country} Flag`}
            width="50"
            height="30"
            className="rounded shadow-sm"
          />
        )}
        <p className="text-sm font-semibold text-gray-700">#{countryRank}</p>
        <p className="text-xs font-medium text-gray-500">
          {course.course_country}
        </p>
      </Link>

      <Link
        to={`/lists/golf-courses/rankings?country=${encodeURIComponent(course.course_country)}`}
        className="flex flex-col gap-y-2 justify-center items-center cursor-pointer hover:border hover:border-gray-300 hover:rounded-xl"
      >
        {countryFlagURL && (
          <img
            src={countryFlagURL}
            alt={`${course.course_country} Flag`}
            width="50"
            height="30"
            className="rounded shadow-sm"
          />
        )}
        <p className="text-sm font-semibold text-gray-700">
          Top {roundedPercentage}%
        </p>
        <p className="text-xs font-medium text-gray-500">GolfLists</p>
      </Link>

      <Link
        to={`/lists/golf-courses/county-ranking/${slugify(course.course_county)}`}
        className="flex flex-col gap-y-2 justify-center items-center cursor-pointer hover:border hover:border-gray-300 hover:rounded-xl"
      >
        {countyFlagURL && (
          <img
            src={countyFlagURL}
            alt={`${course.course_county} Flag`}
            width="50"
            height="30"
            className="rounded shadow-sm"
          />
        )}
        <p className="text-sm font-semibold text-gray-700">
          #{course.county_rank}
        </p>
        <p className="text-xs font-medium text-gray-500 truncate">
          {course.course_county}
        </p>
      </Link>
    </article>
  );
}

export default GolfCourseRank;
